import React, { ChangeEvent, useEffect, useState } from 'react'
import { AppDispatch, RootState } from '../../../reducers/store';
import { useDispatch, useSelector } from 'react-redux';
import {Button, FormField, ImageBuffer, Loader, SubCover, SubmitModal} from '../..';
import { actionFetchAdmins, actionUpdateAdmin } from '../../../actions/admins';
import { adminValidateFirstName, adminValidateLastName } from '../../validations/admins/register';
import toast from 'react-hot-toast';
import { PhotoRounded } from '@mui/icons-material';
import { create } from '../../../assets';

import './editAdminDetails.css'

interface PostDataParams {
  firstName: string;
  lastName: string;
}

const EditAdminDetails = ({id, details}: any) => {
  const pageName                                     = "Edit Admin"
  const dispatch                                     = useDispatch<AppDispatch>();
  const [hideShow, setHideShow]                      = useState<boolean>(false);
  const [savingInfo, setSavingInfo]                  = useState<boolean>(false);
  const [onOpen, setOnOpen]                          = useState<boolean>(false);
  const [firstNameErrors, setFirstNameErrors]        = useState<string[]>([]);
  const [lastNameErrors, setLastNameErrors]          = useState<string[]>([]);
  const [openSubMegaMenu, setOpenSubMegaMenu]        = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled]      = useState<boolean>(true);
  const [errorMessage, setErrorMessage]              = useState<string>();

  const [postData, setPostData]                   = useState<PostDataParams>({firstName: details?.firstName || '', lastName: details?.lastName || ''})
  const [isLoadingBtn, setIsLoadingBtn]           = useState({firstName: false, lastName: false});
  const [isValid, setIsValid]                     = useState({firstName: false, lastName: false});

  const useDebounce = <T,>(value: T, delay: number): T => {
    const [debounced, setDebounced] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebounced(value);
      }, delay);
      return () => clearTimeout(handler);
    }, [value, delay]);
  
    return debounced;
  };

  const debouncedPostData = useDebounce<PostDataParams>(postData, 500);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setIsLoadingBtn((prevState) => ({ ...prevState, [name]: true }));
    setPostData((prevState) => ({ ...prevState, [name]: value }));
  }

  // useEffect(() => {
  //   dispatch(actionFetchAdmins({currentPage})); // You can pass the page number as needed
  // }, [dispatch, currentPage]);

  useEffect(() => {
    const validateFirstName = () => {
      const { isValid, errors } = adminValidateFirstName({ postData: debouncedPostData });
      setIsValid((prevState) => ({
        ...prevState,
        firstName: isValid,
      }));
      setFirstNameErrors(errors);
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        firstName: false,
      }));
      return errors;
    };

    const validateLastName = () => {
      const { isValid, errors } = adminValidateLastName({ postData: debouncedPostData });
      setIsValid((prevState) => ({
        ...prevState,
        lastName: isValid,
      }));
      setLastNameErrors(errors);
      setIsLoadingBtn((prevState) => ({
        ...prevState,
        lastName: false,
      }));
      return errors;
    };


    const firstNameErrors        = validateFirstName();
    const lastNameErrors         = validateLastName();
    
    setFirstNameErrors(firstNameErrors);
    setLastNameErrors(lastNameErrors);

    const hasFormErrors = firstNameErrors.length > 0 || lastNameErrors.length > 0;
    setIsButtonDisabled(hasFormErrors);
  }, [debouncedPostData]);

  const handleModalSubmit = () => {
    setOnOpen(true)
    setOpenSubMegaMenu(true)
  }

  const handleCloseCover = () => {
    setOnOpen(false) // modal
    setOpenSubMegaMenu(false)
  }

  const handleSubmit = async(e: ChangeEvent<any>) => {
    e.preventDefault();
    handleModalSubmit()
  }

  const cancelPostCreation = () => {
    setOnOpen(false); // Close the modal
    setSavingInfo(false);
    setOpenSubMegaMenu(false)
  };

  const confirmPostCreation = async() => {
    setSavingInfo(true);
    setIsButtonDisabled(true);
    const res = await dispatch(actionUpdateAdmin({id, postData}))
    try{
      if (res.success === true) {
        toast.success("user updated successfully");
        setPostData({firstName: res?.data?.firstName || '', lastName: res?.data?.lastName || ''})
        setSavingInfo(false);
      } else if (res?.status === 500) {
        setErrorMessage(res?.message);
        setSavingInfo(false)
      }
    }catch(error: any){
      setErrorMessage("Internal server Error")
      setSavingInfo(false)
    }
  }

  return (
    <>
      <title>{pageName}</title>
      <div className='edit-detail-admin-container'>
        <form className='' onSubmit={handleSubmit} autoComplete="off" >
          <div className='edit-detail-admin-title'>
            <h3>update Admin details</h3>
          </div>

          <div className=''>  
            <FormField inputType type="text" labelName="First Name" name="firstName" value={postData.firstName} handleChange={handleChange} isLoadingBtn={isLoadingBtn.firstName} isValid={isValid.firstName} errors={firstNameErrors || []} />

            <FormField inputType type="text" labelName="Last Name" name="lastName" value={postData.lastName} handleChange={handleChange} isLoadingBtn={isLoadingBtn.lastName} isValid={isValid.lastName} errors={lastNameErrors || []} />

            <SubmitModal onOpen={onOpen} onClose={cancelPostCreation} onConfirm={confirmPostCreation} modalImage={create} prompt="Are you sure you want to update admin" />
            <Button onClickButton buttonClickWrap={savingInfo ? `button-login-submitted` : `button-login-submit`} onClickName={savingInfo ? <>{<Loader />} updating data...</> : "Update Admin"} isButtonDisabled={isButtonDisabled} buttonClasses={savingInfo ? ['button-disabled'] : (isButtonDisabled ? ['buttonDisabledClass'] : ['buttonEnabledClass'])} disabled={savingInfo} />
            
            {errorMessage && (
              <div className="form-response-message">
              <p className="error-msg">{errorMessage}</p>
              </div>
            )}
          </div>
        </form>
      </div>

      {openSubMegaMenu && (
        //z-index: 3, others should be higher
        <SubCover handleCloseCover={handleCloseCover} />
      )}
    </>
  )
}

export default EditAdminDetails